import axios from 'axios';
import { API_BASE } from '../config/apiBase';

const API_BASE_URL = API_BASE;

// Create axios instance for API calls
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add Firebase ID token
api.interceptors.request.use(
  async (config) => {
    try {
      // Use access token stored by AuthContext in localStorage
      const accessToken = localStorage.getItem('access_token');
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    } catch (error) {
      console.error('Error getting Firebase token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;
      
      if (status === 401) {
        console.error('Unauthorized - redirecting to login');
        // Could trigger a redirect to login page here
      } else if (status === 403) {
        console.error('Forbidden - insufficient permissions');
      } else if (status >= 500) {
        console.error('Server error:', data.message || 'Internal server error');
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error('Network error - no response from server');
    } else {
      // Something else happened
      console.error('Request error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;
